import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Iframe from "../../components/Iframe";
import { ConfigSettings } from "../../config/Config";
import { InterviewService } from "../../services/InterviewService";
import { QueryString } from "../../common/helper";
import { iframeService } from "../../services/iFrameService";

const RiseProjectEstimation = ({
  interviewId,
  hash,
  setFullName,
  setUrl,
  url,
  setUrlParameterKey
}) => {
  const settings = ConfigSettings();

  useEffect(() => {
    if (interviewId && !hash) {
      createRiseEstimation();
    } else if (hash) {
      editRiseEstimation();
    } else {
      fallbackRiseStandAloneEstimation();
    }
  }, []);

  async function createRiseEstimation() {
    let interview = await InterviewService.getById(interviewId);
    setFullName(interview.personalInformation.fullName);

    iframeService
      .getProjectEstimationbyInterviewId(interviewId)
      .then((data) => {
        const key = encodeURIComponent(data.key);
        setUrl(settings.riseUrl + `/external/access?k=${key}`);
        setUrlParameterKey(key);
      });
  }

  function editRiseEstimation() {
    setFullName(QueryString.getUrlParameter("fullName"));

    iframeService.getProjectEstimationByHash(hash, interviewId).then((data) => {
      const key = encodeURIComponent(data.key);
      setUrl(settings.riseUrl + `/external/access?k=${key}`);
      setUrlParameterKey(key);
    });
  }
  function fallbackRiseStandAloneEstimation() {
    iframeService.getProjectEstimation().then((data) => {
      const key = encodeURIComponent(data.key);
      setUrl(settings.riseUrl + `/external/access?k=${key}`);
      setUrlParameterKey(key);
    });
  }
  const { t } = useTranslation();
  return url ? <Iframe url={url} title={t("Project Estimation")} /> : null;
};

export default RiseProjectEstimation;
